<app-user-dashboard *ngIf="role !== null && role === 'User'"></app-user-dashboard>
<app-admin-dashboard *ngIf="role !== null && role === 'Admin'"></app-admin-dashboard>
